import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { APP_ROUTES } from '@core/constants';
import { AuthService } from '@core/services';

@Injectable({
  providedIn: 'root'
})
export class TempPasswordGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.authService.hasPendingPasswordChange) {
      return true;
    }

    // No valid session — redirect to login with warning
    this.authService.clearPendingPasswordChange?.(); // just in case
    this.router.navigate([APP_ROUTES.LOGIN], {
      queryParams: { reason: 'session-expired' }
    });

    return false;
  }
}
